import { z } from 'zod';
import { GreenhouseStandardSchema } from '../GreenhouseStandard/validators';
import { GreenhouseStrategySchema } from '../GreenhouseStrategy/validators';
import { GreenhouseGoalTermSchema } from '../GreenhouseGoalTerm/validators';
import { PerformanceGhGasMgmtReportSchema } from '../GreenhouseGasMgmtReport/validators';
import { ClimateChangeStructureSchema } from '../ClimateChangeStructure/validators';
import { OtherExplanationSchema } from '@Containers/OtherExplanations/validators';

export const EsgGreenhouseSchema = z.object({
  greenhouseStandard: GreenhouseStandardSchema,
  greenhouseGoalTerm: GreenhouseGoalTermSchema,
  greenhouseStrategy: GreenhouseStrategySchema,
  climateChangeStructure: ClimateChangeStructureSchema,
  performanceGhGasMgmtReport: PerformanceGhGasMgmtReportSchema,
  otherDescriptions: z.array(OtherExplanationSchema).optional(),
});
